import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getCookie = function (cname) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
    if (cname == cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
};

export default new Vuex.Store({
  state: {
    status: "",
    user: getCookie("user-scancom")
      ? JSON.parse(decodeURI(getCookie("user-scancom")))
      : null
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, user) {
      state.status = "success";
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.user = null;
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        this._vm.$http
          .post("/api/auth/login", user)
          .then(resp => {
            if (resp.data.status == "Success") {
              let data = resp.data.data;
              const user = {
                userName: data.userName,
                fullName: data.fullName,
                firstName: data.firstName,
                token: data.token,
                userType: data.userType,
              };
              this._vm.$func.setCookie(
                "user-scancom",
                encodeURI(JSON.stringify(user)),
                365
              );
              commit("auth_success", user);
            }
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            this._vm.$func.deleteCookie("user-scancom");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit("logout");
          this._vm.$http.post("/api/auth/logout").then(() => {
            this._vm.$func.deleteCookie("user-scancom");
          });
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }
  },
  getters: {
    authStatus: state => state.status,
    authUser: state => state.user
  }
});



// WEBPACK FOOTER //
// ./src/store/user.js